import React, { useState, useEffect } from "react"
import { promotionsData } from "../../data/PromotionData"
import { useLeaderboard } from "../../data/LeaderboardProviderPP"

export default function ModuleRaceOfReels({ closeModal }) {
  const promoData = promotionsData.find(
    (promo) => promo.title === "Race of Reels: Slots Tournament"
  )

  const {
    leaderboardData,
    loadingBoard,
    getBonusByRank,
    playerPosition,
    boardMode,
    setBoardMode,
  } = useLeaderboard()

  const showLD = boardMode === "live"

  return (
    <div className="promotion-module-pop-container">
      <div className="promotion-module-container">
        <button onClick={closeModal} className="promotion-close-btn">
          Close
        </button>

        <div className="promotion-module-main">
          <div className="promotion-leaderboard">
            <div className="promotion-module-banner">
              <img src={promoData.imgSrc} alt="Promotion Banner" />
              <div className="img-overlay"></div>
            </div>

            <div className="king-of-reel-title">
              {showLD ? "LIVE DEALER LEADERBOARD" : "SLOTS LEADERBOARD"}
            </div>

            <table className="promotion-module-table" style={{ marginTop: 5 }}>
              <thead>
                <tr className="love-magic">
                  <th>Rank</th>
                  <th>Username</th>
                  <th>Free Spins</th>
                </tr>
              </thead>
              <tbody>
                {loadingBoard ? (
                  <tr>
                    <td colSpan="3" style={{ textAlign: "center" }}>
                      Loading...
                    </td>
                  </tr>
                ) : leaderboardData.length > 0 ? (
                  leaderboardData.map((row, index) => {
                    const bonusValue = getBonusByRank(row.ranking)
                    const bonusDisplay = bonusValue
                      ? bonusValue.toLocaleString()
                      : "-"

                    return (
                      <tr key={index}>
                        <td>{row.ranking}</td>
                        <td>{row.username}</td>
                        <td>{bonusDisplay}</td>
                      </tr>
                    )
                  })
                ) : (
                  <tr>
                    <td colSpan={3} style={{ textAlign: "center" }}>
                      No Data Found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          <div className="promotion-module-cta">
            <span style={{ fontSize: 13, paddingInline: 10 }}>
              {loadingBoard ? (
                <p>Loading Leaderboard...</p>
              ) : playerPosition ? (
                <p>Race of Reels: Rank#{playerPosition}</p>
              ) : (
                <p>
                  Winners will receive FREE SPINS every{" "}
                  <strong className="highlight">Tuesday - 3:30PM</strong>
                </p>
              )}
            </span>

            <button
              className="promotion-module-leaderboard-btn"
              type="button"
              onClick={() =>
                setBoardMode((m) => (m === "live" ? "slots" : "live"))
              }
            >
              {showLD ? "Slots" : "Live Dealer"}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
